var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({attrs:{"icon":""},on:{"click":_vm.toggleTheme}},'v-btn',_vm.$attrs,false),[_c('v-icon',[(_vm.theme === `new`)?[_vm._v(" fas fa-moon")]:[_vm._v(" fas fa-sun")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }